import React, { useState, useEffect } from 'react'

// Deps
// import omit from 'lodash/omit'

// Functions
// import formatDate from 'functions/format-date';

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'
// import { Table, TR, TD } from 'views/shared/partials/table'
// import Pricebox from 'views/shared/partials/pricebox'

// Services
import companyServices from 'services/company'

const GroupModal = (props) => {
	const close = props.close;
	const groupID = props.groupID;

	const [submitting, setSubmitting] = useState(false);
	const [groupInfo, setGroupInfo] = useState(false);
	const [showCoordinates, setShowCoordinates] = useState(false);

	useEffect(() => {
		if(groupID) {
			companyServices.getGroup(groupID).then((payload) => {
				//let selectedAddition = additionalOptions[0];
				setShowCoordinates(payload.latitude || payload.longitude ? true : false);
				setGroupInfo(payload);
			}).catch(() => { close(); })
		}
		else {
			setGroupInfo(null);
		}
	}, [groupID, close]);

	const submit = (formData) => {
		setSubmitting(true);

		if(groupInfo) {
			formData.installment_id = groupInfo.id;
			formData.create_or_update = 'update';
		}
		else {
			formData.create_or_update = 'create';
		}

		companyServices.createOrUpdateGroup(formData).then(() => {
			if(props.onSuccess) {
				props.onSuccess();
			}
			props.close();
		}).catch(() => {
		}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{groupID ? 'Grubu Düzenle' : 'Grup Oluştur'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={groupInfo === false} />
				<div className="grid-container">
					<div className="row">
						<div className="col x6">
							<FormInput
								type="text"
								disabled={groupInfo === false || submitting}
								label="Grup Adı"
								name="name"
								value={groupInfo ? groupInfo.name : undefined}
								validation={{
									required: 'Bir grup adı girmelisiniz.',
								}} />
						</div>
						<div className="col x6">
							<FormInput
								type="text"
								disabled={groupInfo === false || submitting}
								label="Grup Kodu"
								name="store_code"
								value={groupInfo ? groupInfo.store_code : undefined}
								validation={{
									required: 'Bir grup kodu girmelisiniz.',
								}} />
						</div>
					</div>
					<div className="row">
						<div className="col x12">
							<FormInput
								type="email"
								disabled={groupInfo === false || submitting}
								label="E-Posta Adresi"
								name="email"
								value={groupInfo ? groupInfo.email : undefined}
								validation={{
									required: 'Bir e-posta adresi girmelisiniz.',
									email: true,
								}} />
						</div>
					</div>
					<div className="row">
						<div className="col x6">
							<div className="row">
								<div className="col">
									<FormInput
										type="text"
										disabled={groupInfo === false || submitting}
										label="IBAN"
										mask="iban"
										name="iban"
										value={groupInfo ? groupInfo.iban : undefined}
										validation={{
											iban: true,
										}} />
								</div>
							</div>
							<div className="row">
								<div className="col">
									<FormInput
										type="text"
										disabled={groupInfo === false || submitting}
										label="Fatura Adı"
										name="invoice_name"
										value={groupInfo ? groupInfo.invoice_name : undefined} />
								</div>
							</div>
						</div>
						<div className="col x6 vertical-full">
							<FormInput
								type="textarea"
								disabled={groupInfo === false || submitting}
								label="Fatura Adresi"
								name="invoice_address"
								value={groupInfo ? groupInfo.invoice_address : undefined} />
						</div>
					</div>
					<div className="row">
						<div className="col x6">
							<FormInput
								type="text"
								disabled={groupInfo === false || submitting}
								label="Vergi Numarası"
								name="tax_number"
								value={groupInfo ? groupInfo.tax_number : undefined}
								mask="numeric"
								maxLength={12}
								validation={{
									taxOrID: true
								}} />
						</div>
						<div className="col x6">
							<FormInput
								type="text"
								disabled={groupInfo === false || submitting}
								label="Vergi Dairesi"
								name="tax_office"
								value={groupInfo ? groupInfo.tax_office : undefined} />
						</div>
					</div>
					<div className="row">
						<div className="col x12">
							<FormInput
								disabled={submitting}
								type="checkbox"
								checked={showCoordinates}
								onChange={(val) => { setShowCoordinates(val ? true : false); }}
								value={1}
								label="Lokasyon gir" />
						</div>
					</div>
					{showCoordinates &&
						<div className="row">
							<div className="col no-gap-top x6">
								<FormInput
									type="number"
									mask="number"
									data-delimiter="."
									options={{ delimiter: '', numeralDecimalMark: '.' }}
									decimals={10}
									disabled={groupInfo === false || submitting}
									label="Enlem"
									name="latitude"
									validation={{
										required: 'Bir enlem girmelisiniz.',
									}}
									value={groupInfo ? groupInfo.latitude : undefined} />
							</div>
							<div className="col no-gap-top x6">
								<FormInput
									type="number"
									mask="number"
									options={{ delimiter: '', numeralDecimalMark: '.' }}
									decimals={10}
									disabled={groupInfo === false || submitting}
									label="Boylam"
									name="longitude"
									validation={{
										required: 'Bir boylam girmelisiniz.',
									}}
									value={groupInfo ? groupInfo.longitude : undefined} />
							</div>
						</div>
					}
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={props.close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting || groupInfo === false}
					type="submit">
					{groupID ? 'Kaydet' : 'Oluştur'}
				</Btn>
			</div>
		</InputForm>
	)
}

GroupModal.defaultProps = {
	className: '',
	containerClass: 'modal-group mobile-full',
	name: 'group',
}

export default GroupModal